import { Modal } from '../ui/modal';
import { MfaEnrollFlow } from './MfaEnrollFlow';

/**
 * The optional Settings enrollment dialog (Feature 25): wraps the shared
 * {@link MfaEnrollFlow} in a modal. `onEnabled` fires when a factor becomes
 * active (so the Security card refreshes); the modal closes on "Done".
 *
 * A fresh flow (new secret) mounts each time the dialog opens because the flow
 * is only rendered while `open` is true.
 */
export function MfaSetupDialog({
  open,
  onClose,
  onEnabled,
}: {
  open: boolean;
  onClose: () => void;
  onEnabled: () => void;
}) {
  return (
    <Modal
      open={open}
      onClose={onClose}
      maxWidth="2xl"
      title={
        <h2 className="font-display text-lg font-bold text-bone">
          Set up two-factor authentication
        </h2>
      }
    >
      {open && <MfaEnrollFlow onDone={onClose} onActivated={onEnabled} />}
    </Modal>
  );
}
